import * as React from "react"
import Slider from "react-slick"
import { TextWith4Covers } from "../../../../custom_api/collection/api"
import { Link } from "../../library/link"
import { setCustomArrowsFocus } from "../../quick_links"
import { scrollAdviceIntoView } from "../Advice/Advice"

type BookSliderProps = {
  popularThemes: TextWith4Covers[]
  pushDataLayer: (action: string, label: string) => void
  routePath: string,
  selectionPrompt: string
}

export default class BookSlider extends React.Component<BookSliderProps> {
  render() {

    const { popularThemes, pushDataLayer, routePath, selectionPrompt } = this.props

    const settings = {
      accessibility: true,
      dots: true,
      arrows: true,
      infinite: false,
      variableWidth: true,
      className: "bookslider",
      dotsClass: "bookslider-dots",
      speed: 500,
      swipeToSlide: true,
      slidesToScroll: 4,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 1041,
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 793,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 545,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
          }
        }
      ],
      onReInit: () => {
        const slides = document.querySelectorAll('.slick-slide');
        slides.forEach((slide) => {
          slide.setAttribute('aria-hidden', 'false')
        })
        setCustomArrowsFocus()
        const dots = document.querySelectorAll('.bookslider-dots li');
        if (dots == null || dots.length == 0) { return; }
        dots.forEach((dot, key) => {
          if (dot.classList.contains('slick-active')) { dot.setAttribute('aria-current', 'true') }
          else { dot.removeAttribute('aria-current') }
        })
      },
      slickPrev: () => {
        setCustomArrowsFocus()
      },
      slickNext: () => {
        setCustomArrowsFocus()
      },

      customPaging: (i) => (
        <button tabIndex={-1}>
          <span className="sr-txt">Navigeer naar pagina {i + 1} van carousel</span>
          <span aria-hidden="true">{i + 1}</span>
        </button>
      )
    };

    return (
      <div className="block block--slider-book slider">
        <div className="slider__inner">
          <div className="slider__content">
            <div className="layout__header ip__header--bookslider">
              <h2 className="layout__title layout__title--center">{selectionPrompt}</h2>
            </div>
            <Slider {...settings}>
              {popularThemes.map(theme =>
                <Link
                  key={"link_" + theme.name}
                  className="slider__item-link"
                  handle={() => {
                    pushDataLayer("Klik op onderwerp suggestie", theme.name);
                    scrollAdviceIntoView();
                  }}
                  url={`/${routePath}/thema/${theme.name}`}
                >
                  <span className="slider__name">{theme.name}</span>
                  <div className="slider__visual">
                    <div className="slider__visual-visuals">
                      {theme.covers.length > 0 ?
                        theme.covers.map((x) => <img key={"img_" + x} className="slider__image" src={`${x ? x : "/book-foto.png"}`} width="105" height="150" alt={"Foto van het boek"} />) :
                        <>
                          <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"Foto van het boek"} />
                          <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"Foto van het boek"} />
                          <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"Foto van het boek"} />
                          <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"Foto van het boek"} />
                        </>
                      }
                    </div>
                  </div>
                </Link>)}
            </Slider>
          </div>
        </div>
      </div>
    )
  }
}
